import { User } from '../../../../../../apis/users';

// The switch lives on the prescriber's link to this clinic, so only the clinic's own prescriber list carries it.
export function isShownOnClinic(userId: string, clinicPrescribers: User[]): boolean {
  return clinicPrescribers.some((prescriber) => prescriber._id === userId && prescriber.show_on_clinic === true);
}
